<template>
  <div class="hello uk-padding">
    <div class="uk">
      <ul uk-accordion="multiple: true">
        <li class="uk-open">
          <a class="uk-accordion-title" href="#">Global parameters</a>
          <div class="uk-accordion-content">
            <GlobalConfigs v-bind:id="configs[0].id" />
          </div>
        </li>
        <li class="uk-closed">
          <a class="uk-accordion-title" href="#">Parameter Sets</a>
          <div class="uk-accordion-content">
            <Configurations />
          </div>
        </li>
        <li class="uk-open">
          <a class="uk-accordion-title" href="#">Models</a>
          <div class="uk-accordion-content">
            <ul uk-tab>
              <li
                class=""
                v-bind:class="{ 'uk-active': config.id == visiblePredictionId }"
                v-for="config in configs"
                v-bind:id="config.id"
                v-bind:key="config.id"
              >
                <a href="" v-on:click="setVisibleTable(config.id)">{{
                  config.name
                }}</a>
              </li>
            </ul>
            <div v-for="config in configs" v-bind:key="config.id">
              <ChurnTable
                v-bind:id="config.id"
                v-if="visiblePredictionId == config.id"
              >
              </ChurnTable>
            </div>

            <div>
              <button
                class="uk-button uk-button-primary uk-button-large"
                type="button"
                v-on:click="exportExcel"
              >
                Export to Excel
              </button>
              <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
              <button class="uk-button" type="button" v-on:click="resetData">
                resetData
              </button>
            </div>
          </div>
        </li>
      </ul>

      <div id="my-id" uk-modal>
        <div class="uk-modal-dialog uk-modal-body">
          <h2 class="uk-modal-title"></h2>
          <button class="uk-modal-close" type="button"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChurnTable from "@/components/churn/ChurnTable.vue";
import Configurations from "@/components/churn/Configurations.vue";
import GlobalConfigs from "@/components/churn/GlobalConfigs.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "HelloWorld",
  components: {
    ChurnTable,
    Configurations,
    GlobalConfigs,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      visiblePredictionId: "",
    };
  },
  methods: {
    ...mapActions({
      exportExcel: "churn/createExcel",
    }),
    setVisibleTable(id) {
      this.visiblePredictionId = id;
    },
    resetData() {
      localStorage.clear();
    },
  },
  created() {
    if (this.configs && this.configs.length > 0) {
      this.visiblePredictionId = this.configs[0].id;
    }
  },
  computed: {
    ...mapState({
      configs: (state) => state.churn.configs,
    }),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
